import type { DeepPartial } from "../types";
import type { MaterialCharacteristics } from "../material";
import type {
  ItemMaterialCharacteristics,
  ProductMaterialCharacteristics,
} from "./products.types";

export const buildProductMaterialCharacteristics = (
  teeth: number[],
  items: ReadonlyArray<{
    tooth: number;
    materialCharacteristics?: MaterialCharacteristics;
  }>
): DeepPartial<ProductMaterialCharacteristics> => {
  const materialCharacteristicsByTooth = new Map(
    items.map(item => [item.tooth, item.materialCharacteristics] as const)
  );

  return {
    items: teeth.map(tooth => ({
      tooth,
      materialCharacteristics: materialCharacteristicsByTooth.get(tooth),
    })),
  };
};

export const hasDistinctItemCharacteristics = (
  items: ReadonlyArray<{
    materialCharacteristics?: DeepPartial<MaterialCharacteristics>;
  }>
): boolean => {
  const distinctCharacteristics = new Set(
    items.map(item => JSON.stringify(item.materialCharacteristics))
  );
  return distinctCharacteristics.size > 1;
};

export const getCompleteItemCharacteristics = (
  items: ReadonlyArray<DeepPartial<ItemMaterialCharacteristics>> | undefined
): ItemMaterialCharacteristics[] =>
  (items ?? []).filter(
    (item): item is ItemMaterialCharacteristics =>
      typeof item?.tooth === "number" && !!item?.materialCharacteristics
  );
